import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Pagination from "react-bootstrap/Pagination";
import { Link } from "react-router-dom";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import styles from "./style.module.css";
import Menubar from "../../../components/MenuBar/Menubar";
import DashboardNavbar from "../../../components/DashBoardNavbar";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const Navigate = useNavigate();
  const [jobApplications, setJobApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [filteredItems, setFilteredItems] = useState([]);
  // const Navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("authtoken");

    if (!authToken) {
      setTimeout(() => {
        Navigate("/");
      }, 3000);
      return; // Exit early if authToken is missing
    }

    const fetchJobApplications = async () => {
      try {
        const requestOptions = {
          method: "GET",
          headers: {
            "auth-token": authToken,
            Authorization: "Bearer yourToken",
            "Content-Type": "application/json",
          },
        };
        const response = await fetch(
          "https://job-application-mindtech.onrender.com/api/job-applications/",
          requestOptions
        );
        if (!response.ok) {
          setTimeout(() => {
            Navigate("/");
          }, 2000);
          throw new Error("Network response was not ok", error);
        }
        const data = await response.json();
        setJobApplications(data.data);
        setLoading(false);
        setTimeout(() => {}, 10000);

        // Initially set filtered items to all job applications
        setFilteredItems(data.data);
      } catch (error) {
        setTimeout(() => {
          Navigate("/");
        }, 2000);
        setError(error.message || "An error occurred while fetching data.");
        setLoading(false);
      }
    };

    fetchJobApplications();
  }, [Navigate, error]);

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearch(searchTerm);
    const filtered = jobApplications.filter((item) => {
      return Object.values(item).some(
        (value) =>
          typeof value === "string" && value.toLowerCase().includes(searchTerm)
      );
    });
    setFilteredItems(filtered);
    setCurrentPage(1); // Reset to first page when searching
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className={styles.record}>
        <Menubar />
        <Container className={styles.container}>
          <DashboardNavbar />
          <div className={styles.tags}>
            <h1 className={styles.tableTag1}>Dashboard</h1>
            <h3 className={styles.tableTag2}>Welcome back, Admin</h3>
          </div>
          <Form>
            <InputGroup className="my-3">
              <Form.Control
                onChange={handleSearch}
                value={search}
                placeholder="Search application"
              />
            </InputGroup>
          </Form>
          <Table className={styles.table}>
            <thead className={styles.thead}>
              <tr>
                <th>Task Name</th>
                <th>User Name</th>
                <th>Job Role</th>
                <th>Date Applied</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tbody}>
              {currentItems.map((application) => (
                <tr key={application._id}>
                  <td></td>
                  <td>{application.name}</td>
                  <td>{application.jobRole}</td>
                  <td>{application._id}</td>
                  <td>
                    <Link
                      to={`/applicationDetails/${application._id}`} // Pass _id as part of the URL
                      style={{ color: "#192BC2", textDecoration: "true" }}
                    >
                      view Application
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination style={{ marginLeft: "15vw" }}>
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => paginate(currentPage - 1)}
            >
              <NavigateBeforeIcon />
            </Pagination.Prev>
            <Pagination.Next
              disabled={
                currentPage === Math.ceil(filteredItems.length / itemsPerPage)
              }
              onClick={() => paginate(currentPage + 1)}
            >
              <NavigateNextIcon />
            </Pagination.Next>
          </Pagination>
        </Container>
      </div>
    </div>
  );
}

export default Dashboard;
